import {Injectable} from '@angular/core';
import {AuthService} from '../../core/security/auth.service';
import {ReportsService as ReportsApiService} from '../../api/services/reports.service';
import * as _ from 'lodash';
import {UsersSummaryExportRequest} from '../../api/models/users-summary-export-request';
import {ReportsService} from '../reports.service';

@Injectable()
export class UsersSummaryService {

  public exportDomainsColumns: any[] = [
    {id: _.uniqueId('id_'), field: '_id', title: 'Domain', width: 10},
    {id: _.uniqueId('id_'), field: 'total', title: 'Total Calls', width: 10},
    {id: _.uniqueId('id_'), field: 'totalLocal', title: 'Total Local Calls', width: 10},
    {id: _.uniqueId('id_'), field: 'totalIncoming', title: 'Total Incoming Calls', width: 10},
    {id: _.uniqueId('id_'), field: 'totalOutgoing', title: 'Total Outgoing Calls', width: 10},
    // {id: _.uniqueId('id_'), field: 'totalMailbox', title: 'Total Mailbox Calls', width: 10},
    {id: _.uniqueId('id_'), field: 'totalMailboxExcludeInternals', title: 'Total Mailbox Calls', width: 10},
    // {id: _.uniqueId('id_'), field: 'totalGroup', title: 'Total Group Calls', width: 10},
    // {id: _.uniqueId('id_'), field: 'totalMissed', title: 'Total Missed Calls', width: 10},
    {id: _.uniqueId('id_'), field: 'totalMissedExcludeInternals', title: 'Total Missed Calls', width: 10},
    // {id: _.uniqueId('id_'), field: 'totalAnswered', title: 'Total Answered Calls', width: 10},
  ];

  public exportColumns: any[] = [
    {id: _.uniqueId('id_'), field: '_id', title: 'Account Number', width: 10},
    {id: _.uniqueId('id_'), field: 'name', title: 'Name', width: 10},
    {id: _.uniqueId('id_'), field: 'totalCount', title: 'Total Calls', width: 10},

    {id: _.uniqueId('id_'), field: 'totalOutgoingCount', title: 'Outgoing Total Calls', width: 10},
    {id: _.uniqueId('id_'), field: 'totalOutgoingAnswered', title: 'Outgoing Answered', width: 10},
    {id: _.uniqueId('id_'), field: 'totalOutgoingMissed', title: 'Outgoing Missed', width: 10},

    {id: _.uniqueId('id_'), field: 'totalIncomingCount', title: 'Incoming Total Calls', width: 10},
    {id: _.uniqueId('id_'), field: 'totalIncomingAnswered', title: 'Incoming Answered', width: 10},
    {id: _.uniqueId('id_'), field: 'totalIncomingMailbox', title: 'Incoming Mailbox', width: 10},
    {id: _.uniqueId('id_'), field: 'totalIncomingMissed', title: 'Incoming Missed', width: 10},

    {id: _.uniqueId('id_'), field: 'totalInternalCount', title: 'Internal Total Calls', width: 10},
    {id: _.uniqueId('id_'), field: 'totalInternalAnswered', title: 'Internal Answered', width: 10},
    {id: _.uniqueId('id_'), field: 'totalInternalMailbox', title: 'Internal Mailbox', width: 10},
    {id: _.uniqueId('id_'), field: 'totalInternalMissed', title: 'Internal Missed', width: 10},

    {id: _.uniqueId('id_'), field: 'totalQueuesCount', title: 'Queues Total Calls', width: 10},
    {id: _.uniqueId('id_'), field: 'totalQueuesAnswered', title: 'Queues Answered', width: 10},
    {id: _.uniqueId('id_'), field: 'totalQueuesMailbox', title: 'Queues Mailbox', width: 10},
    {id: _.uniqueId('id_'), field: 'totalQueuesMissed', title: 'Queues Missed', width: 10},
  ];
  public aggregates: any[] = [
    {field: 'totalCount', aggregate: 'sum'},

    {field: 'totalOutgoingCount', aggregate: 'sum'},
    {field: 'totalOutgoingAnswered', aggregate: 'sum'},
    {field: 'totalOutgoingMissed', aggregate: 'sum'},

    {field: 'totalIncomingCount', aggregate: 'sum'},
    {field: 'totalIncomingAnswered', aggregate: 'sum'},
    {field: 'totalIncomingMailbox', aggregate: 'sum'},
    {field: 'totalIncomingMissed', aggregate: 'sum'},

    {field: 'totalInternalCount', aggregate: 'sum'},
    {field: 'totalInternalAnswered', aggregate: 'sum'},
    {field: 'totalInternalMailbox', aggregate: 'sum'},
    {field: 'totalInternalMissed', aggregate: 'sum'},

    {field: 'totalQueuesCount', aggregate: 'sum'},
    {field: 'totalQueuesAnswered', aggregate: 'sum'},
    {field: 'totalQueuesMailbox', aggregate: 'sum'},
    {field: 'totalQueuesMissed', aggregate: 'sum'},
  ];

  constructor(private authService: AuthService, private reportsApiService: ReportsApiService, public reportsService: ReportsService) {

  }

  public async exportLogs(state: UsersSummaryExportRequest): Promise<void> {
    console.log(state);

    const body = await this.reportsApiService.usersSummaryGetExport({body: state}).toPromise();
    const blob = new Blob([this.s2ab(atob(body))], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.style.display = 'none';
    document.body.appendChild(a);

    a.href = url;
    a.download = 'agents-summary.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);

    return;
  }

  s2ab(s: string) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
  }
}
